<div #spotEntry class="order-entry__screen-order__body oe-spot-entry">
  <!-- CLIENT -->
  <div #panelClient class="order-entry__panel-client-details__container">
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        class="order-entry__panel-client-details__data-client"
        #inputClient
        mode="client"
        [disabled]="data.client.disabled"
        [constraint]="data.account.value"
        [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
        [(ngModel)]="data.client.value"
        (ngModelChange)="onClientChange($event)"
        [externalState]="data.client.externalState"
        (onClientSelect)="onClientSelect($event)"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>
    <div class="order-entry__panel-order-details__row">
      <ic-autocomplete
        class="order-entry__panel-client-details__data-account"
        #inputAccount
        mode="account"
        [disabled]="data.account.disabled"
        [constraint]="data.client.value"
        [constraintAutoSelect]="control.clientAccountConstraintAutoSelect"
        [(ngModel)]="data.account.value"
        (ngModelChange)="onAccountChange($event)"
        [externalState]="data.account.externalState"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>

    <div class="order-entry__panel-order-details__row">
      <bfx-contacts-input
        [ngClass]="{
          'order-entry__panel-client-details__data-contacts': true,
          'order-entry__panel-client-details__data-contacts--full-size': true
        }"
        #inputContacts
        inputId="contacts"
        [client]="data.client.value"
        [label]="data.contacts.label"
        [disabled]="data.clientTrader.disabled"
        [selectedTrader]="data.clientTrader.value"
        [(ngModel)]="data.contacts.value"
        (contactChanged)="onContactsChange($event)"
        [externalState]="data.contacts.externalState"
        (traderChanged)="onClientTraderUpdate($event)"
        (commentsChanged)="onClientDefaultCommentsChanged($event)"
        (contactManagerOpen)="onContactManagerOpen($event)"
        (contactManagerClosed)="onContactManagerClosed($event)"
        [fieldsGroup]="true"
      >
      </bfx-contacts-input>
    </div>
    <div class="order-entry__panel-order-details__row" *ngIf="data.clientTrader.enabled">
      <ic-autocomplete
        class="order-entry__panel-client-details__client-trader"
        #inputClientTrader
        mode="client_trader"
        [label]="data.clientTrader.label"
        [disabled]="data.clientTrader.disabled"
        [constraint]="data.client.value"
        [(ngModel)]="data.clientTrader.value"
        (ngModelChange)="onClientTraderChange($event)"
        [externalState]="data.clientTrader.externalState"
        [entryType]="entryType"
        [fieldsGroup]="true"
      >
      </ic-autocomplete>
    </div>
    <!-- OBO *ngIf="oboEnabled" -->
    <div *ngIf="false" class="order-entry__panel-obo__container">
      <div class="order-entry__panel-obo__row">
        <bfx-text-input
          #oboClient
          class="order-entry__panel-obo__input"
          [(ngModel)]="data.oboClient.value"
          [disabled]="data.oboClient.disabled"
          [size]="'sm'"
          [inputLabelText]="'OBO Client'"
          type="search"
          autocomplete="off"
          maxlength="255"
          (ngModelChange)="updateOBOClient($event)"
        ></bfx-text-input>
      </div>
      <div class="order-entry__panel-obo__row">
        <bfx-text-input
          #oboAccount
          class="order-entry__panel-obo__input"
          [(ngModel)]="data.oboAccount.value"
          [inputLabelText]="'OBO Account'"
          [disabled]="data.oboClient.disabled"
          [size]="'sm'"
          type="search"
          autocomplete="off"
          maxlength="255"
          (ngModelChange)="updateOBOAccount($event)"
        ></bfx-text-input>
      </div>
    </div>
    <!-- TABS -->
    <p-tabView
      #tabs
      styleClass="bfx-tabview"
      class="order-entry__screen-order__tab-view"
      [activeIndex]="tabIndex"
      (onChange)="onTabActivate($event)"
    >
      <p-tabPanel
        class="order-entry__panel-financials__tab-panel"
        [header]="tabData.financials.label"
      >
        <!-- FINANCIALS -->
        <div #panelFinancials class="order-entry__panel-financials__container">
          <div class="order-entry__panel-financials__row">
            <ic-ccy-pair-string
              #inputCcyPair
              class="order-entry__panel-financials__ccy-pair"
              inputId="currencyPair"
              [entryType]="entryType"
              [label]="data.currencyPair.label"
              [dataset]="data.currencyPair.dataset"
              [inverted]="data.currencyPair.inverted"
              [(ngModel)]="data.currencyPair.product"
              (blur)="onCcyPairBlur($event)"
              [externalState]="data.currencyPair.externalState"
            >
            </ic-ccy-pair-string>
            <ic-autocomplete
              #inputOrderType
              class="order-entry__panel-financials__order-type"
              inputId="orderType"
              mode="type"
              [label]="data.orderType.label"
              [disabled]="data.orderType.disabled"
              [dataset]="data.orderType.dataset"
              [(ngModel)]="data.orderType.value"
              (ngModelChange)="onOrderTypeChange($event, true)"
              [externalState]="data.orderType.externalState"
              [entryType]="entryType"
            >
            </ic-autocomplete>
          </div>

          <div
            class="order-entry__panel-financials__row"
            [style.display]="!control.showIntentAndAmount?'none':'flex'"
          >
            <div class="order-entry__panel-financials__client-intent-container">
              <bfx-client-intent-toggle
                fxFlex="1 1 50%"
                id="oe-control_client-intent"
                #toggleClientIntent
                class="order-entry__panel-financials__client-intent"
                inputId="clientIntent"
                [label]="data.clientIntent.label"
                [(ngModel)]="data.clientIntent.value"
                (ngModelChange)="onClientIntentToggleChange($event)"
                [externalState]="data.clientIntent.externalState"
              >
              </bfx-client-intent-toggle>
              <ic-fixed-ccy
                class="order-entry__panel-financials__fixed-ccy"
                [ccyPair]="data.fixedCcy.ccyPair"
                [(ngModel)]="data.fixedCcy.value"
                (ngModelChange)="onFixedCcyToggleChange($event)"
              >
              </ic-fixed-ccy>
            </div>
            <bfx-amount-spinner
              #inputOrderAmount
              class="order-entry__panel-financials__order-amount"
              [label]="data.orderAmount.label"
              [currency]="data.fixedCcy.fixedCcy"
              [(ngModel)]="data.orderAmount.value"
              (ngModelChange)="onOrderAmountChange($event)"
              (blur)="onOrderAmountBlur($event)"
              [externalState]="data.orderAmount.externalState"
              [size]="'sm'"
            >
            </bfx-amount-spinner>
          </div>

          <!-- For strategy with a CALL Order at the root, we want to define the strategy wide ccy -->
          <div
            class="order-entry__panel-financials__row"
            [style.display]="!control.showRootCallCcy?'none':'flex'"
          >
            <ic-fixed-ccy
              label="Strategy Currency"
              class="order-entry__panel-financials__strategy-ccy"
              [ccyPair]="data.fixedCcy.ccyPair"
              [(ngModel)]="data.fixedCcy.value"
              (ngModelChange)="onFixedCcyToggleChange($event)"
            >
            </ic-fixed-ccy>
            <div class="order-entry__panel-financials__strategy-ccy"></div>
          </div>

          <div class="order-entry__panel-financials__row">
            <bfx-price-spinner
              #inputRequestPrice
              class="order-entry__panel-financials__request-price"
              [label]="data.requestPrice.label"
              [productCode]="data.currencyPair.product"
              [inverted]="data.currencyPair.inverted"
              [(ngModel)]="data.requestPrice.value"
              (ngModelChange)="onRequestPriceChange($event)"
              [externalState]="data.requestPrice.externalState"
              [size]="'sm'"
            >
            </bfx-price-spinner>
            <bfx-ndf-value-date
              class="order-entry__panel-financials__value-date"
              #inputValueDate
              [ngClass]="inputValueDate.classes"
              [label]="data.valueDate.label"
              [disabled]="data.valueDate.disabled"
              [(ngModel)]="data.valueDate.value"
              scrollHeight="120px"
              [entryType]="entryType"
              [(dataset)]="data.valueDate.dataset"
              (ngModelChange)="onValueDateChange($event)"
              (reEvaluateTrigger)="reEvaluateTrigger($event)"
              (reEvaluateFixingDate)="reEvaluateFixingDate($event)"
              [externalState]="data.valueDate.externalState"
            >
            </bfx-ndf-value-date>
          </div>

          <div class="order-entry__panel-financials__row">
            <bfx-autoComplete
              #inputFixingSource
              class="order-entry__panel-financials__fixing_code"
              [allowEmptySelection]="false"
              [useAlternateBlur]="true"
              [emptyIsInactive]="true"
              [state]="data.fixingSource.locked ? 3 : data.fixingSource.state"
              [disabled]="data.fixingSource.locked"
              [(ngModel)]="data.fixingSource.value"
              [suggestions]="data.fixingSource.dataSet"
              [skipSorting]="true"
              (completeMethod)="searchFixingSources($event)"
              (onFocus)="fixingSourceFocus()"
              (onClear)="onClearFixingSource()"
              (onBlur)="fixingSourceBlur()"
              (onUnselect)="onClearFixingSource()"
              (onSelect)="onSelectFixingSource()"
              [dropdown]="true"
              delay="5"
              field="label"
              dataKey="value"
              [label]="data.fixingSource.label"
              [minLength]="0"
              [maxlength]="50"
              [appendTo]="'body'"
              nativeDesktopDropdown="fixingSource"
              target="fixingSource"
              [size]="'sm'"
            >
            </bfx-autoComplete>
            <bfx-calendar
              #inputFixingDate
              appendTo="body"
              [label]="data.fixingDate.label"
              class="order-entry__panel-financials__fixing-date"
              panelStyleClass="bfx-calendar__dropdown__container"
              nativeDesktopCalendar="fixingDateCalendar"
              target="fixingDateCalendar"
              dateFormat="DD-MMM-YYYY"
              [showIcon]="true"
              [updateOnSelect]="true"
              [adjustForTimeZone]="true"
              [(ngModel)]="data.fixingDate.value"
              [showDateInput]="true"
              [hideOnDateTimeSelect]="true"
              [showActionsBar]="false"
              (onSelect)="fixingDateSelected($event)"
              [minDateAdjustment]="0"
              [minDate]="data.fixingDate.minDate"
              [maxDate]="data.fixingDate.maxDate"
              [alignToAutocompleteInput]="false"
              [disabled]="data.fixingDate.locked||data.fixingDate.disabled||!this.data.valueDate.isBrokenDate"
            >
            </bfx-calendar>
          </div>

          <div class="order-entry__panel-financials__row">
            <bfx-markup
              [style.display]="data.markup.config.markupEnabled && data.markup.show ? 'flex': 'none'"
              #inputMarkup
              class="order-entry__panel-financials__data-markup"
              [label]="data.markup.label"
              [pair]="data.currencyPair.model"
              [isInvert]="data.currencyPair.inverted"
              [markupCriteria]="data.markup.criteria"
              [disabled]="!data.markup.config.markupEntry"
              [retrieveEnabled]="data.markup.retrieveEnabled"
              [(ngModel)]="data.markup.value"
              [trackingRate]="data.trackingRate.textValue"
              [clientRate]="data.clientRate.textValue"
              (ngModelChange)="onMarkupChange($event)"
              (onGetMarkupCriteria)="onGetMarkupCriteria($event)"
              (onMarkupCheckboxState)="onMarkupCheckboxState($event)"
              [externalState]="data.markup.externalState"
            >
            </bfx-markup>
            <bfx-autoComplete
              [style.display]="(entryType == 2 || (data.valueDate && data.valueDate.value && !data.valueDate.isSpot ? 'flex': 'none'))"
              #inputTrigger
              class="order-entry__panel-financials__trigger"
              [useAlternateBlur]="true"
              [alternateConfig]="control.triggerAutocompleteConfig"
              [emptyIsInactive]="true"
              [state]="data.trigger.locked ? 3 : data.trigger.state"
              [disabled]="data.trigger.locked"
              [(ngModel)]="data.trigger.value"
              [suggestions]="data.trigger.dataset"
              [skipSorting]="true"
              (completeMethod)="searchTriggers($event)"
              nativeDesktopDropdown="valueDate"
              target="valueDate"
              (onFocus)="triggerFocus()"
              (onSelect)="onSelectTrigger($event)"
              (onBlur)="onSelectTrigger($event)"
              [dropdown]="true"
              delay="5"
              field="label"
              dataKey="value"
              [label]="data.trigger.label"
              [minLength]="0"
              [maxlength]="50"
              [appendTo]="'body'"
              [size]="'sm'"
            >
            </bfx-autoComplete>
          </div>
          <hr class="oe__panel__hr" />
          <!-- PANE DUE -->
          <div class="order-entry__panel-good-from-until__row">
            <bfx-good-from-until
              #inputGoodFrom
              [mode]="data.goodFrom.mode"
              class="input-good-from order-entry__panel-financials__good-from"
              [label]="data.goodFrom.label"
              panelStyleClass="order-entry__panel-financials__goodfrom-calendar"
              [disabled]="data.goodFrom.locked"
              [placeholder]="data.goodFrom.placeholder"
              [(ngModel)]="data.goodFrom.value"
              [constraint]="data.goodUntil.value"
              [externalState]="data.goodFrom.externalState"
              [errorMsg]="data.goodFrom.errorMsg"
              [tooltipLabel]="data.goodFrom.tooltip"
              (ngModelChange)="onGoodFromChange()"
            >
            </bfx-good-from-until>
          </div>
          <div class="order-entry__panel-good-from-until__row">
            <bfx-good-from-until
              #inputGoodUntil
              [mode]="data.goodUntil.mode"
              class="input-good-until order-entry__panel-financials__good-until"
              panelStyleClass="order-entry__panel-financials__gooduntil-calendar"
              [label]="data.goodUntil.label"
              [placeholder]="data.goodUntil.placeholder"
              [disabled]="data.goodUntil.locked"
              [(ngModel)]="data.goodUntil.value"
              [constraint]="data.goodFrom.value"
              [externalState]="data.goodUntil.externalState"
              [errorMsg]="data.goodUntil.errorMsg"
              [tooltipLabel]="data.goodUntil.tooltip"
              (ngModelChange)="onGoodUntilChange()"
            >
            </bfx-good-from-until>
          </div>
          <div class="order-entry__panel-financials__row">
            <!-- SUSPEND -->
            <bfx-suspend-control
              #inputSuspend
              [style.display]="data.suspend.show ? 'flex': 'none'"
              class="order-entry__panel-financials__data-suspend"
              [labelFrom]="data.suspend.from.label"
              [labelTo]="data.suspend.to.label"
              [externalState]="data.suspend.externalState"
              [(ngModel)]="data.suspend.value"
              (ngModelChange)="onSuspendChange($event)"
            >
            </bfx-suspend-control>
          </div>
          <div class="order-entry__panel-financials__row">
            <!-- HOLD STP -->
            <ic-hold-stp
              class="order-entry__panel-more__cell"
              #inputHoldSTP
              [label]="data.holdSTP.label"
              [config]="data.holdSTP.enabledConfig"
              [client]="data.client.value"
              [account]="data.account.value"
              [loading]="control.isLoading"
              [(ngModel)]="data.holdSTP.value"
              (ngModelChange)="onHoldSTPChange()"
            >
            </ic-hold-stp>
            <!-- TRADER GROUP -->
            <bfx-autoComplete
              #inputTraderGroup
              class="order-entry__panel-financials__trader-group"
              [useAlternateBlur]="true"
              [alternateConfig]="control.traderGroupAutocompleteConfig"
              [emptyIsInactive]="true"
              [state]="!data.traderGroup.traderGroupModifiable||data.traderGroup.locked ? 3 : data.traderGroup.state"
              [disabled]="!data.traderGroup.traderGroupModifiable||data.traderGroup.locked"
              inputId="trader-input"
              nativeDesktopDropdown="traderGroup"
              target="traderGroup"
              [(ngModel)]="data.traderGroup.value"
              [suggestions]="data.traderGroup.traderGroups"
              (completeMethod)="searchTraderGroup($event)"
              (onFocus)="traderGroupFocus()"
              (onSelect)="onSelectTraderGroup($event)"
              (onBlur)="onSelectTraderGroup($event)"
              [dropdown]="true"
              delay="5"
              field="groupCode"
              dataKey="groupId"
              [label]="data.traderGroup.label"
              [minLength]="0"
              [maxlength]="50"
              [appendTo]="'body'"
              [size]="'sm'"
            >
            </bfx-autoComplete>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel [header]="tabData.more.label" class="order-entry__panel-financials__more-panel">
        <!-- MORE -->
        <div class="order-entry__panel-more__container">
          <!-- PANE UNO -->
          <div class="order-entry__panel-more__comments">
            <!-- CLIENT COMMENT -->
            <div class="order-entry__panel-more__comments-client__container">
              <div class="order-entry__panel-more__comments-client__row">
                <p-checkbox
                  *ngIf="data.commentClient.checkbox.show"
                  [bfxInputLabelOnClick]="commentClientLabel"
                  [ngClass]="{
                    'bfx-checkbox-enable-control': true,
                    'order-entry__panel-more__comments-client__checkbox': true,
                    'order-entry__panel-more__comments-client__checkbox--checked': data.commentClient.checkbox.value && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__checkbox--unchecked': !data.commentClient.checkbox.value && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__checkbox--locked': data.commentClient.locked
                  }"
                  binary="true"
                  [(ngModel)]="data.commentClient.checkbox.value"
                  [disabled]="data.commentClient.locked"
                  (ngModelChange)="onCommentClientCheckboxChange()"
                ></p-checkbox>
                <div
                  [ngClass]="{
                    'bfx-input-label': true,
                    'bfx-input-label-sm-bold': true,
                    'bfx-input-label-invalid': this.data.commentClient.externalState == 1 && !data.commentClient.locked,
                    'bfx-input-label-disabled':data.commentClient.locked || this.data.commentClient.externalState == 1,
                    'bfx-input-label-enabled': !(data.commentClient.locked || this.data.commentClient.externalState == 1),
                  }"
                  #commentClientLabel
                >
                  {{data.commentClient.label}}
                </div>
              </div>
              <div class="order-entry__panel-more__comments-client__row">
                <textarea
                  [rows]="hasCustomFields?2:4"
                  pInputTextarea
                  #inputCommentClient
                  [ngClass]="{
                    'order-entry__panel-more__comments__textarea': true,
                    'order-entry__panel-more__comments-client__input': true,
                    'order-entry__panel-more__comments-client__input--invalid': this.data.commentClient.externalState == 1 && !data.commentClient.locked,
                    'order-entry__panel-more__comments-client__input--active': (data.commentClient.checkbox.show && data.commentClient.checkbox.value && !data.commentClient.locked) || (!data.commentClient.checkbox.show && !data.commentClient.locked),
                    'order-entry__panel-more__comments-client__input--inactive': !(this.data.commentClient.externalState == 1 && !data.commentClient.locked) && (data.commentClient.checkbox.show && !data.commentClient.checkbox.value || data.commentClient.locked) || (!data.commentClient.checkbox.show && data.commentClient.locked)
                  }"
                  [(ngModel)]="data.commentClient.value"
                  (ngModelChange)="onContactManagerClosed($event)"
                  [maxlength]="control.commentSize"
                  [disabled]="data.commentClient.locked || (data.commentClient.checkbox.show && !data.commentClient.checkbox.value)"
                  (onFocus)="$event.target.select()"
                  (blur)="onCommentClientChange();"
                ></textarea>
              </div>
            </div>
            <bfx-comment-warning></bfx-comment-warning>
            <!-- PRIVATE COMMENT -->
            <div class="order-entry__panel-more__comments-private__row">
              <div
                [ngClass]="{
                  'bfx-input-label': true,
                  'bfx-input-label-sm-bold': true,
                  'bfx-input-label-disabled':data.commentPrivate.locked,
                  'bfx-input-label-enabled': !(data.commentPrivate.locked),
            }"
                class="order-entry__panel-more__comments-private__label"
              >
                {{data.commentPrivate.label}}
              </div>
            </div>
            <div class="order-entry__panel-more__comments-private__row">
              <textarea
                [rows]="hasCustomFields?2:4"
                pInputTextarea
                [ngClass]="{
              'order-entry__panel-more__comments__textarea': true,
              'order-entry__panel-more__comments-private__input': true,
              'order-entry__panel-more__comments-private__input--active': !data.commentPrivate.locked,
              'order-entry__panel-more__comments-private__input--inactive': data.commentPrivate.locked
            }"
                [(ngModel)]="data.commentPrivate.value"
                (ngModelChange)="onContactManagerClosed($event)"
                [maxlength]="control.commentSize"
                [disabled]="data.commentPrivate.locked"
                (focus)="$event.target.select()"
                (blur)="onCommentPrivateChange();"
              ></textarea>
            </div>
          </div>
          <bfx-comment-warning *ngIf="data.commentPrivate.show"></bfx-comment-warning>
        </div>
        <hr class="oe__panel__hr" />
        <!-- PANE DUE -->
        <div class="order-entry__panel-more__extras">
          <div class="order-entry__panel-more__row">
            <!-- EXECUTION MODE -->
            <ic-execution-mode
              class="order-entry__panel-more__cell"
              [ngStyle]="{
                'visibility': data.executionMode.show ? 'visible': 'hidden'
              }"
              #inputExecutionMode
              inputId="execution-mode"
              [label]="data.executionMode.label"
              [loading]="control.isLoading"
              [client]="data.client.value"
              [(ngModel)]="data.executionMode.value"
              (ngModelChange)="onExecutionModeChange()"
            >
            </ic-execution-mode>
          </div>
          <div
            class="order-entry__panel-more__row"
            [ngStyle]="{
              'display':  data.privateOrder.show || data.partialFill.show  ? 'flex': 'none'
            }"
          >
            <!-- PRIVATE ORDER -->
            <ic-private-order
              class="order-entry__panel-more__cell"
              [ngStyle]="{
                'visibility': data.privateOrder.show  ? 'visible': 'hidden'
              }"
              #inputPrivateOrder
              [loading]="control.isLoading"
              [label]="data.privateOrder.label"
              [(ngModel)]="data.privateOrder.value"
              (ngModelChange)="onPrivateOrderChange()"
            >
            </ic-private-order>
            <!-- ALLOW PARTIAL FILLS -->
            <ic-allow-partial-fills
              class="order-entry__panel-more__cell"
              [ngStyle]="{
                'visibility': data.partialFill.show  ? 'visible': 'hidden'
              }"
              #inputAllowPartialFills
              [loading]="control.isLoading"
              [client]="data.client.value"
              [orderType]="data.orderType.value"
              [label]="data.partialFill.label"
              [(ngModel)]="data.partialFill.value"
              (ngModelChange)="onAllowPartialFillsStateChange()"
            >
            </ic-allow-partial-fills>
          </div>
          <div
            class="order-entry__panel-more__row"
            [ngStyle]="{
              'display': data.stpAgg.show  ? 'flex': 'none'
            }"
          >
            <!-- ALLOW STP AGG -->
            <ic-allow-stpagg
              class="order-entry__panel-more__cell"
              #inputAllowSTPAgg
              [loading]="control.isLoading"
              [config]="data.stpAgg.enabledConfig"
              [label]="data.stpAgg.label"
              [(ngModel)]="data.stpAgg.value"
              (ngModelChange)="onAllowStpAggStateChange()"
            >
            </ic-allow-stpagg>
          </div>
        </div>
        <hr class="oe__panel__hr" />
        <!-- MORE Custom Fields -->
        <div *ngIf="hasCustomFields" class="order-entry__panel-more__custom-fields">
          <div class="order-entry__panel-more__custom-fields__container">
            <ic-custom-fields
              #customFieldComponent
              [operationMode]="operationMode"
              (valuesChanged)="onCustomValuesChange($event)"
              [externalState]="data.customValues.externalState"
            ></ic-custom-fields>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
